// Central catalog of analytics event names and actions.
//
// Two GA4 event names ("buckets") are used; individual features are
// distinguished by the `action` param. Centralising the action strings keeps
// them typo-free and gives a single place to see what the UI reports.
//
// PRIVACY: only pass ids/enums/counts/booleans as params (e.g. our own
// sample/view/lens ids, FIX tag *numbers*, counts, status/type enums). Never
// pass FIX message content, tag *values*, titles, file/dictionary names, or
// filter values. sanitizeParams() in gtag.ts enforces this at runtime.

export const EVENT = {
  INPUT: "use_input",
  SETTINGS: "use_settings",
} as const;

export const ACTION = {
  // input / parsing
  PARSE_INPUT: "parse_input",
  SAMPLE_LIBRARY: "sample_library",
  RANDOM_SAMPLE: "random_sample",
  COPY_CLIPBOARD: "copy_clipboard",
  COPY_MESSAGE_ROW: "copy_message_row",

  // view & grid
  CHANGE_VIEW_MODE: "change_view_mode",
  FILTER_MESSAGES_GRID: "filter_messages_grid",
  FILTER_DETAILS_GRID: "filter_details_grid",
  SELECT_MESSAGE: "select_message",
  TOGGLE_TIME_FORMAT: "toggle_time_format",

  // timeline
  TIMELINE_SELECT_MESSAGE: "timeline_select_message",
  TIMELINE_RESET_ZOOM: "timeline_reset_zoom",
  TIMELINE_FILTER_MSGTYPE: "timeline_filter_msgtype",

  // column customization
  CHANGE_CUSTOM_COLUMNS: "change_custom_columns",
  OPEN_COLUMNS_SETTINGS: "open_columns_settings",
  ADD_CUSTOM_COLUMN: "add_custom_column",
  QUICK_ADD_COLUMN: "quick_add_column",
  DELETE_COLUMN: "delete_column",
  REORDER_COLUMNS: "reorder_columns",
  OPEN_GROUP_FILTER: "open_group_filter",
  SAVE_GROUP_FILTER: "save_group_filter",
  REMOVE_GROUP_FILTER: "remove_group_filter",

  // dictionary
  UPLOAD_DICTIONARY: "upload_dictionary",
  LOAD_SAVED_DICTIONARY: "load_saved_dictionary",
  SAVE_EXTERNAL_DICTIONARY: "save_external_dictionary",
  DELETE_SAVED_DICTIONARY: "delete_saved_dictionary",
  VIEW_DICTIONARY_CONTENT: "view_dictionary_content",

  // header / global
  CUSTOM_TITLE: "custom_title",
  RESET_STATE: "reset_state",
  DARK_MODE_TOGGLE: "dark_mode_toggle",
  EXPORT_AS_CSV: "export_as_csv",

  // identity
  VIEW_IDENTITY_VALIDATION: "view_identity_validation",

  // code lens
  CODE_LENS_RUN: "code_lens_run",
  CODE_LENS_INTERRUPT: "code_lens_interrupt",
  CODE_LENS_RESET: "code_lens_reset",
  CODE_LENS_COPY: "code_lens_copy",
} as const;

export type AnalyticsAction = (typeof ACTION)[keyof typeof ACTION];
